const titleCase = (text: string) =>
  text
    ?.toLowerCase()
    .split(' ')
    .map((word) => word.replace(word[0], word[0]?.toUpperCase()))
    .join(' ');

const dollarAmount = (amount: number) =>
  `$${`${amount.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

const date = (text: string) => `${new Date(text).toLocaleDateString()}`;

export default {
  titleCase,
  dollarAmount,
  date,
};
